import copy from 'copy-to-clipboard';
import { memo } from 'react';
import toast from 'react-hot-toast';
import { installationSteps } from '../../../static/mock';
import CopyIcon from '../../../static/svgs/Copy';
import CustomDialog from '../../shared/Dialog/CustomDialog';
import CustomSelect from '../../shared/Forms/CustomSelect';
import text from '../../shared/css/text.module.scss';
import shared from '../../shared/shared.module.scss';
import theme from '../../utils/theme';
import styles from './device.module.scss';
import { centosVersions, kaliVersions, osOptions, prepareCentOSCommand, prepareKaliCommand, prepareUbuntuCommand, prepareWindowsCommand, ubuntuVersions, windowsVersions } from './helper';

const AddDeviceDialog = ({ isDeviceOpen, handleDeviceDialog, curlCommand, setCurlCommand, copied, setCopied, selectedOs, setSelectedOs, selectedVersion, setSelectedVersion, selectedDeviceToken }) => {


    const handleChangeCurlCommand = (os, version, token) => {
        switch (os) {
            case 'windows':
                return setCurlCommand(prepareWindowsCommand(token, version))
            case 'ubuntu':
                return setCurlCommand(prepareUbuntuCommand(token, version))
            case 'centos':
                return setCurlCommand(prepareCentOSCommand(token, version))
            case 'kali':
                return setCurlCommand(prepareKaliCommand(token, version))
            default:
                return setCurlCommand(prepareWindowsCommand(token, version))
        }
    }

    const handleChangeOs = (event) => {
        setSelectedOs(event.target.value);
        switch (event.target.value) {
            case 'windows':
                setSelectedVersion(windowsVersions?.[0]?.value);
                handleChangeCurlCommand(event.target.value, windowsVersions?.[0]?.value, selectedDeviceToken)
                break
            case 'ubuntu':
                setSelectedVersion(ubuntuVersions?.[0]?.value);
                handleChangeCurlCommand(event.target.value, ubuntuVersions?.[0]?.value, selectedDeviceToken)
                break;
            case 'centos':
                setSelectedVersion(centosVersions?.[0]?.value)
                handleChangeCurlCommand(event.target.value, centosVersions?.[0]?.value, selectedDeviceToken)
                break
            case 'kali':
                setSelectedVersion(kaliVersions?.[0]?.value)
                handleChangeCurlCommand(event.target.value, kaliVersions?.[0]?.value, selectedDeviceToken)
                break;
            default:
        }


    };

    const handleChangeVersion = (event) => {
        setSelectedVersion(event.target.value);
        handleChangeCurlCommand(selectedOs, event.target.value, selectedDeviceToken)

    };

    const handleCopy = () => {
        copy(curlCommand);
        setCopied(true)
        toast.success('Copied')
    }

    const handleVersionOptions = (value) => {
        switch (value) {
            case 'windows':
                return windowsVersions;
            case 'ubuntu':
                return ubuntuVersions
            // case 'centos':
            //     return centosVersions
            // case 'kali':
            //     return kaliVersions
            default:
                return windowsVersions;

        }
    }
    return (
        <CustomDialog title={'Installation Steps:'} isOpen={isDeviceOpen} handleToggle={handleDeviceDialog} maxWidth={'sm'}>
            <div className={styles.messageContainer}>
                <p className={text.normal2}>Choose installation steps:</p>
                {installationSteps?.map((item, idx) => (
                    <div key={idx} className={styles.textItem}>
                        <div className={`${shared.circle} ${styles.bgBlue}`} > </div>
                        <p className={text.normal1}>{item}</p>
                    </div>
                ))}
            </div>
            <div>
                <br />
                <CustomSelect
                    label="Select OS"
                    required
                    options={osOptions}
                    value={selectedOs}
                    onChange={handleChangeOs}
                />
                <br />
                <CustomSelect
                    label="Select Version"
                    required
                    options={handleVersionOptions(selectedOs)}
                    value={selectedVersion}
                    onChange={handleChangeVersion}
                />
                <br />
            </div>
            <div className={styles.row}>
                <p className={text.formLabel}>Command:</p>
                <div style={{ backgroundColor: copied ? theme.palette.primary.light : theme.palette.primary.main }} onClick={handleCopy} className={`${styles.copyBtn} copy-icon`}>
                    <CopyIcon />
                </div>
            </div>
            <br />
            <p className={`${text.small1} ${styles.commandText}`}>{curlCommand}</p>
            <br />
        </CustomDialog>
    );
}

export default memo(AddDeviceDialog)

